import { render } from "./AptPassActionButtons.vue?vue&type=template&id=0f031b09"
import script from "./AptPassActionButtons.vue?vue&type=script&lang=js"
export * from "./AptPassActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__